import { Link } from "gatsby";
import React, { MouseEvent, useRef } from "react";
import classNames from "classnames";
import "./menuItem.scss";
import Icon from "components/icon/Icon";
import { TransLink } from "components/trans/transLink";
import { useLocation } from "@reach/router";

interface menuItemData {
  id: string;
  children?: any;
  label: string;
  path: string;
  target?: string;
  cssClasses?: string[];
  parentId?: string;
  isSubNavItem?: boolean;
  isActive: boolean;
}

interface Props extends menuItemData {
  className?: string;
  classNameSub?: string;
  onClick?: (id: string) => void;
  onHover?: (id: string) => void;
  onLeave?: (id: string) => void;
  onSubnavClose?: () => void;
  isSubOpen?: boolean;
  isGrey?: boolean;
  activeItemId?: string;
}

const MenuItem: React.FC<Props> = (props) => {
  const subnavRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const renderInnerInner = () => (
    <>
      {props.cssClasses?.includes("has-glow") && (
        <div className="button__glow" />
      )}
      <span
        className={classNames({
          "button-label": props.cssClasses?.includes("button"),
        })}
      >
        {props.label}
      </span>
      {!!props.children && !!props.children.length && (
        <Icon icon="arrow" size="13px" className="menu-item-arrow" />
      )}
    </>
  );

  const renderMenuItemInner = () => {
    if (
      props.target === "_blank" ||
      props.path === "#" ||
      props.path.includes("http")
    ) {
      return (
        <a
          href={props.path}
          target={props.target || "_self"}
          className={classNames(props.cssClasses)}
        >
          {renderInnerInner()}
        </a>
      );
    }

    return (
      <TransLink
        to={props.path}
        data-is-link={true}
        className={classNames(props.cssClasses)}
      >
        {renderInnerInner()}
      </TransLink>
    );
  };

  const handleItemClick = (e: MouseEvent) => {
    if (!!props.children && !!props.children.length) {
      e.preventDefault();
      props.onClick && props.onClick(props.isSubOpen ? "" : props.id);
    }
    if (props.isSubNavItem) {
      !!props.onClick && props.onClick("");
    }
  };

  const handleItemHover = (e: MouseEvent) => {
    if (!!props.children && !!props.children.length && props.onHover) {
      e.preventDefault();
      props.onHover(props.id);
    }
  };

  const handleItemLeave = (e: MouseEvent) => {
    if (!!props.children && !!props.children.length && props.onHover) {
      e.preventDefault();
      !!props.onLeave && props.onLeave(props.id);
    }
  };

  return (
    <li
      className={classNames(props.className || undefined, "menu-item", {
        "is-sub-open": props.isSubOpen,
        "is-active": props.isActive,
      })}
      onClick={handleItemClick}
      onMouseOver={handleItemHover}
      onMouseLeave={handleItemLeave}
      id={props.id}
    >
      {renderMenuItemInner()}
      {!!props.children && !!props.children.length && (
        <div
          className="menu-item-collapse"
          style={{
            height: props.isSubOpen
              ? `${subnavRef.current ? subnavRef.current.clientHeight : 0}px`
              : "0",
          }}
        >
          <div
            className={`${props.classNameSub} ${props.id === 'cG9zdDoxNw==' ? 'locations' : ''}`}
            id={`${props.id}-sub`}
            ref={subnavRef}
          >
            <ul className={`${props.classNameSub}-list ${props.id}`}>
              {props.id === 'cG9zdDoxNw==' && <div className="location-region">North America</div>}
              {props.children.map((item: menuItemData, key: number) => {
                return (
                  <MenuItem
                    {...item}
                    key={key}
                    isSubNavItem
                    isActive={!!location.pathname.match(item.path)}
                    onClick={() => {
                      !!props.onSubnavClose && props.onSubnavClose();
                    }}
                  />
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </li>
  );
};

export default MenuItem;
